import EventMultiselect from './EventMultiselect';

export default EventMultiselect;
